export const currencyFormatter = new Intl.NumberFormat(process.env.DJANGO_LANGUAGE_CODE || 'en-us', {
    style: 'currency',
    currency: process.env.DJANGO_DEFAULT_CURRENCY || 'USD',
    minimumFractionDigits: 2,
});